import { translationsMapping } from '../../config'

export const getSetCategoryLink = (setCategory = null, parent = null) => {
	const parentCategory = setCategory ? parent || setCategory.parent : parent

	return `/sets${parentCategory && parentCategory.parent && parentCategory.parent.parent ? `/${parentCategory.parent.parent.slug}` : ''}${parentCategory && parentCategory.parent ? `/${parentCategory.parent.slug}` : ''}${parentCategory ? `/${parentCategory.slug}` : ''}${setCategory ? `/${setCategory.slug}` : ''}`
}

export const getHelpLink = (userLanguage, suffix = '') => `${translationsMapping[userLanguage] === 'de' ? 'https://help.cardcluster.com/de' : 'https://help.cardcluster.com'}${suffix}`
